import { gql, TypedDocumentNode } from "@apollo/client";

import { IntentChatConversation, QueryIntentChatConversationArgs } from "types/generated";

import { CHAT_CONVERSATION_MESSAGES_FRAGMENT } from "../gql";

type ChatConversationData = {
  intentChatConversation: IntentChatConversation | null;
};

export const CHAT_CONVERSATION: TypedDocumentNode<
  ChatConversationData,
  QueryIntentChatConversationArgs
> = gql`
  query ChatConversation($id: ID!) {
    intentChatConversation(id: $id) {
      ...ChatConversationMessages
    }
  }
  ${CHAT_CONVERSATION_MESSAGES_FRAGMENT}
`;
